<div class="nhsuk-form-group">
  <span class="nhsuk-label">{{ label }}</span>
  <ul id="categories" class="selected-items" title="Missing Vaccines, select to remove item">
    @for (item of itemsSelected; track item) {
      <li
        class="list-item pickedItem"
        (click)="onRemoveSelection(item.value)"
        (keyup.enter)="onRemoveSelection(item.value)"
        tabindex="0"
      >
        <strong class="nhsuk-tag nhsuk-tag--blue selected">
          <span>{{ item.label }} </span>
          <svg
            fill="#000000"
            height="12px"
            width="12px"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 490 490"
            xml:space="preserve"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <polygon
                points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490 489.292,457.678 277.331,245.004 489.292,32.337 "
              ></polygon>
            </g>
          </svg>
        </strong>
      </li>
    }
  </ul>
  <details class="nhsuk-details multiPickOpener">
    <summary class="nhsuk-details__summary onFocusYellow">
      <span class="nhsuk-details__summary-text">Add {{ label }}</span>
    </summary>
    <div class="nhsuk-details__text withScroll">
      @if (itemsArray) {
        <label class="nhsuk-u-visually-hidden" for="search-{{ label }}">Filter {{ label }}</label>
        <input
          id="search-{{ label }}"
          class="nhsuk-input search-input"
          type="text"
          [formControl]="searchControl"
          placeholder="Filter {{ label }}"
          autocomplete="off"
          role="searchbox"
        />
        <ul class="others-list" role="listbox" [attr.aria-label]="'Available ' + label">
          @for (item of filteredItems; track item) {
            <li
              class="list-item"
              role="option"
              [attr.aria-selected]="false"
              (click)="onAddItemToSelection(item)"
              (keyup.enter)="onAddItemToSelection(item)"
              tabindex="0"
            >
              <strong class="nhsuk-tag nhsuk-tag--white multiItem">
                {{ item.label }}
              </strong>
            </li>
          }
        </ul>
      }
    </div>
  </details>
</div>
